import { useFontFamily } from '@eastcoal/editor/hooks/useFontFamily'

import { FontFamilySelect as CommonFontFamily } from '../../../components/FontFamilySelect'

export const FontFamilySelect = () => {
  const { fontFamily, setFontFamily } = useFontFamily()

  return (
    <CommonFontFamily
      style={{ width: 140 }}
      value={fontFamily}
      onChange={setFontFamily}
    />
  )
}
